export default __webpack_public_path__ + "static/media/office.389a9fa6.svg";